import { render, staticRenderFns } from "./platIncomeManagement.vue?vue&type=template&id=7c9a54a1"
import script from "./platIncomeManagement.vue?vue&type=script&lang=js"
export * from "./platIncomeManagement.vue?vue&type=script&lang=js"
import style0 from "./platIncomeManagement.vue?vue&type=style&index=0&id=7c9a54a1&prod&scpoed=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports